<template>
  <div id="list">
    <div class="box" v-for="item in list" :key="item.id">
      <div v-if="item.list_image">
        <router-link :to="{path: '../../news/detail',query:{id:item.id,title:item.title}}" target="_blank">
          <img :src="item.list_file" />
        </router-link>
      </div>
      <div>
        <router-link :to="{path: '../../news/detail',query:{id:item.id,title:item.title}}" target="_blank">
          <div class="tit">
            <span class="color_000"> {{item.title}}</span>
          </div>
        </router-link>
        <div class="tbox">
          <div class="type">{{item.type_abb}}</div>
          <div class="time" style="margin-left: 5px;">{{item.publish_date}}</div>
        </div>
        <div class="textlookdiv_name">
          {{item.abstract}}
          <router-link :to="{path: '../../news/detail',query:{id:item.id,title:item.title}}" target="_blank">
            <span>查看全文></span>
          </router-link>
        </div>
      </div>
    </div>
    <div id="pages" v-if="list.length > 0">
      <el-pagination id="pagelist" :page-size="10" :pager-count="7" layout="prev, pager, next" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <div v-if="list.length == 0" class="nodata">
      暂无资讯数据
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
    total: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('_fromPage', val);
    },
    Spanclick(item) {
      this.$router.push({
        path: '../../news/detail',
        query: { id: item.id },
      });
    },
  },
};
</script>

<style lang='scss' scoped>
#list {
  padding-bottom: 24px;
  .textlookdiv_name {
    color: #808080;
    font-size: 13px;
  }
}
.tit .color_000 {
  color: rgba(0, 0, 0, 0.8);
  font-size: 18px;
}
.box > div,
.tbox > div {
  display: inline-block;
  vertical-align: top;
}
.box > div:first-child {
  margin-right: 23px;
}
.box > div:nth-child(2) {
  width: 460px;
}
.box {
  padding: 40px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.box:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
img {
  width: 276px;
  height: 155px;
  cursor: pointer;
}
.nodata {
  padding: 24px;
  text-align: center;
  color: #888;
  font-size: 14px;
}
.tit {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 16px;
}
.tbox {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.48);
  margin-bottom: 30px;
}
span {
  font-size: 14px;
  color: #ff6600;
  cursor: pointer;
}
.type {
  position: relative;
  margin-right: 8px;
}

.type::after {
  content: '';
  position: absolute;
  width: 1px;
  height: 60%;
  top: 4px;
  right: -7px;
  background-color: rgba(0, 0, 0, 0.48);
}

#pages {
  margin-top: 32px;
  text-align: right;
}
#pagelist li.active {
  color: #ff6600 !important;
}
.box a:hover {
  text-decoration: none;
}
</style>
